export default "__VITE_ASSET__Brc0pmQm__"